import { FC, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { postAsync } from "../../services/ApiHandler";
import { useHeaderStore } from "../../parts/CommonHeader";
import { isLoggedIn } from "../../services/CookieHandler";
import { getAccountId } from "../../services/CookieHandler";

export const LiteFreePlanPage: FC = () => {
  const search = useLocation().search;
  const { fetchActiveSubscription, fetchRemainCount } = useHeaderStore();

  useEffect(() => {
    const query = new URLSearchParams(search);
    const sessionId = query.get('session_id');
    if (sessionId !== undefined && isLoggedIn()) {
      postSessionId(sessionId!.toString());
    }
    
    // もしもアフィリエイトコンバージョンタグ追加
    const accountId = getAccountId();
    if (accountId) {
      // scriptタグ追加
      const script = document.createElement('script');
      script.src = `https://r.moshimo.com/af/r/result.js?p_id=6647&pc_id=18942&m_v=${accountId}_lite`;
      script.id = 'msmaf';
      document.body.appendChild(script);
      
      // noscriptタグの代替としてimgタグ追加
      const img = document.createElement('img');
      img.src = `https://r.moshimo.com/af/r/result?p_id=6647&pc_id=18942&m_v=${accountId}_lite`;
      img.width = 1;
      img.height = 1;
      img.alt = '';
      img.style.display = 'none';
      document.body.appendChild(img);
    }
    
    // Rentracksトラッキングスクリプト追加
    function loadScriptRTCV(callback: () => void) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://www.rentracks.jp/js/itp/rt.track.js?t=' + (new Date()).getTime();
      
      if ('readyState' in script) {
        (script as any).onreadystatechange = function() {
          if ((script as any).readyState === 'loaded' || (script as any).readyState === 'complete') {
            (script as any).onreadystatechange = null;
            callback();
          }
        };
      } else {
        script.onload = function() {
          callback();
        };
      }
      
      document.getElementsByTagName('head')[0].appendChild(script);
    }

    loadScriptRTCV(function() {
      (window as any)._rt = (window as any)._rt || {};
      const _rt = (window as any)._rt;
      _rt.sid = 10285;
      _rt.pid = 14691;
      _rt.price = 0;
      _rt.reward = -1;
      _rt.cname = '';
      _rt.ctel = '';
      _rt.cemail = '';
      _rt.cinfo = '0';
      if (typeof (window as any).rt_tracktag === 'function') {
        (window as any).rt_tracktag();
      }
    });
  }, []);

  async function postSessionId(sessionId: string) {
    const param = {
      sessionId: sessionId
    };
    await postAsync<string>("Stripe/CompletePurchase", param); 
    fetchActiveSubscription();
    fetchRemainCount();
  }

  return <>
    <Helmet>
      <title>Liteアップグレード完了</title>
      <meta name="description" content="無料トライアル申込完了" />
    </Helmet>
    <div className="mt-4 text-base sm:text-lg font-bold">無料トライアルの申込が完了しました！</div>
  </>;
}
